export const theme = {
  lockedPromoCodeOfferFillColor: '#ff8631',
  textTransform: Styles.textTransform.headlines,
  expiresPrefix: '',
};
